// extracted by mini-css-extract-plugin
export default {"body2":"body2--kaDBK","body2-semi-bold":"body2-semi-bold--Z87kl"};